import * as amplitude from "@amplitude/analytics-browser";
import { get } from "lodash";
import { KEYS } from "utils/constants";

const readEnv = (value) =>
  value && !String(value).startsWith("__RUNTIME_") ? value : null;

const API_KEY = readEnv(process.env.REACT_APP_AMPLITUDE_API_KEY);
const SERVER_ZONE =
  readEnv(process.env.REACT_APP_AMPLITUDE_SERVER_ZONE) === "EU" ? "EU" : "US";

let initialized = false;

const readStaffUser = () => {
  try {
    return JSON.parse(localStorage.getItem(KEYS.USER)) || undefined;
  } catch {
    return undefined;
  }
};

const readStaffUserId = () => get(readStaffUser(), "id") || undefined;

export const initAmplitude = () => {
  if (!API_KEY) return false;
  if (initialized) return true;
  amplitude.init(API_KEY, readStaffUserId(), {
    serverZone: SERVER_ZONE,
    autocapture: {
      sessions: true,
      pageViews: false,
      attribution: true,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  });
  initialized = true;
  return true;
};
